import globalData from "../globalData"
import { InputBoX, MenuOption } from "./Default"

/**用户登录类 */
class UserLogin{
  constructor() {
    /**用户名 */
    this.username = ''
    /**密码 */
    this.password = ''
    /**再次确认密码 */
    this.passwordAgain = ''
    /**验证码 */
    this.verityCode = ''
    /**手机号码 */
    this.phone = ''
    /**手机验证码 */
    this.phoneVerityCode = ''
    /**邮箱 */
    this.email = ''
    /**邮箱验证码 */
    this.emailVerityCode = ''
    /**验证码图片地址 */
    this.verityImgUrl = '/api/login/getVerity'
  }
  /**判断两次密码是否一致 */
  judgePasswordSame(){
    return this.password === this.passwordAgain
  }
  /**初始化数据 */
  initData(){
    this.username = ''
    this.password = ''
    this.passwordAgain = ''
    this.verityCode = ''
    this.phone = ''
    this.phoneVerityCode = ''
    this.email = ''
    this.emailVerityCode = ''
  }
  /**登录请求体 */
  get getLoginAxiosBody(){
    return {
      'username': this.username,
      'password': this.password,
      'code': this.phoneVerityCode,
      "verity": this.verityCode
    }
  }
  /**获取邮箱验证码(找回密码)请求体 */
  get getEmailVerityCodeAxiosBody(){
    return {
      'email': this.email
    }
  }
  /**获取手机验证码(找回密码)请求体 */
  get getPhoneVerityCodeAxiosBody(){
    return{
      'phone': '+86' + this.phone
    }
  }
  /**获取手机登录验证码请求体 */
  get getPhoneLoginCodeAxiosBody(){
    let obj = {
      'param': this.username
    }
    return obj
  }
  /**通过手机找回密码请求体 */
  get getPhoneFindPasswordAxiosBody(){
    return {
      'phone': '+86' + this.phone,
      'verity': this.verityCode,
      'newPassword': this.password,
      'newPasswordConfirm': this.passwordAgain
    }
  }
  /**通过邮箱找回密码 */
  get getEmailFindPasswordAxiosBody(){
    return {
      'email': this.email,
      'verity': this.verityCode,
      'newPassword': this.password,
      'newPasswordConfirm': this.passwordAgain
    }
  }
  /**切换验证码图片 */
  switchVerityImg(){
    this.verityImgUrl = '/api/login/getVerity?' + new Date()
  }
  /**判断是否可以登录 */
  judgeIsLogin(bool){
    let obj = this.getLoginAxiosBody
    let keys = Object.keys(obj)
    if(!bool){
      keys = keys.filter(key => key != 'code')
    }
    return keys.every(k => obj[k] != '')
  }
}

/**用户信息 */
class UserInfo{
  constructor() {
    /**用户ID */
    this.id = ''
    /**用户权限 */
    this.role = ''
    /**用户名 */
    this.username = ''
    /**邮箱 */
    this.email = ''
    /**手机号码 */
    this.phone = ''
    /**到期时间 */
    this.expirationTime = ''
  }
  /**权限名称 */
  get permissionName(){
    return globalData.permissionNameObj[this.role]
  }
  /**会员ID字符串 */
  get idString(){
    let length = Math.abs(this.id.split('').length - 5)
    let str = new Array(length).fill(0).join('')
    return 'cb_9708' + str + this.id
  }
  /**剩余天数 */
  get daysLeft(){
    let date = new Date()
    if(this.expirationTime <  date) return 0
    return Math.floor((this.expirationTime - date) / 1000 / 60 / 60/ 24)
  }
}

/**用户登录输入框类 */
class UserLoginInputBox extends InputBoX{
  constructor(type, name, data, obj = {icon: 0, unit: 0, decimal: 0, pla: '', html: false}){
    super(type, name, data, obj)
  }
}

/**找回密码菜单选项 */
class FindPasswordMenuOption extends MenuOption{
  constructor(name, id) {
    super(name, id)
  }
}

/**用户输入模块创建类 */
class UserInputNewModule{
  /**登录输入模块 */
  static NEWUSERLOGININPUT(){
    let arr = [
      new UserLoginInputBox('text', '用户名', 'username', { pla: '请输入用户名' }),
      new UserLoginInputBox('password', '密码', 'password', { pla: '请输入密码' }),
      new UserLoginInputBox('verityCode', '验证码', 'verityCode', { pla: '请输入验证码' }),
      new UserLoginInputBox('verityPhone', '手机验证码', 'phoneVerityCode', { pla: '请输入手机验证码' }),
    ]
    return arr
  }
  /**找回密码菜单选项 */
  static NEWFINDPASSWORDMENU(){
    let arr = [
      new FindPasswordMenuOption('邮箱找回', 'email'),
      new FindPasswordMenuOption('手机找回', 'phone')
    ]
    return arr
  }
  /**通过邮箱找回密码 */
  static NEWFINDPASSWORDBYEMAIL(){
    let arr = [
      new UserLoginInputBox('text', '邮箱', 'email', { pla: '请输入邮箱' }),
      new UserLoginInputBox('text', '邮箱验证码', 'emailVerityCode', { pla: '请输入邮箱验证码' }),
      new UserLoginInputBox('password', '设置新密码', 'password', { pla: '请输入新密码' }),
      new UserLoginInputBox('password', '确认密码', 'passwordAgain', { pla: '请再次确认密码' }),
    ]
    return arr
  }
  /**通过手机找回密码 */
  static NEWFINDPASSWORDBYPHONE(){
    let arr = [
      new UserLoginInputBox('text', '手机号码', 'phone', { pla: '请输入手机号码' }),
      new UserLoginInputBox('text', '手机验证码', 'phoneVerityCode', { pla: '请输入手机验证码' }),
      new UserLoginInputBox('password', '设置新密码', 'password', { pla: '请输入新密码' }),
      new UserLoginInputBox('password', '确认密码', 'passwordAgain', { pla: '请再次确认密码' }),
    ]
    return arr
  }
}

export{
  UserLogin, UserInputNewModule, UserInfo
}
